import {
  h,
  render,
} from 'vue';
import Toast from './Toast';

const TOAST_GAP = 16;
const toasts = {
  top: [],
  left: [],
  right: [],
  bottom: [],
  'bottom-left': [],
  'bottom-right': [],
  center: [],
};

export function close(id, placement, afterClose) {
  const idx = toasts[placement].findIndex(({ vm }) => id === vm.component.props.id);
  if (idx === -1) return;

  const { vm } = toasts[placement][idx];
  if (!vm) return;
  if (afterClose) afterClose(vm);
  const removedHeight = vm.el.offsetHeight;
  const verticalPos = placement === 'left' || placement === 'right'
    ? 'top'
    : placement.split('-')[0];
  toasts[placement].splice(idx, 1);

  const len = toasts[placement].length;
  if (len < 1) return;
  for (let i = idx; i < len; i += 1) {
    const { el, component } = toasts[placement][i].vm;
    if (el) {
      const pos = parseInt(el.style[verticalPos], 10) - removedHeight - TOAST_GAP;
      component.props.offset = pos;
    }
  }
}

/*
  Used to show feedback after an activity.
  @param { String } Toast can take a string as parameter
  @param { String } placement attribute defines which corner the Toast slides in: top, left, right, bottom, bottom-right or bottom-left. Default top
  @param { Number } duration before close. It will not automatically close if set to 0
  @param { Number } offset from the top edge of the screen.
  @param { Number } max attribute defines which when the toast not automatically close and there are too many - older ones disappear
 */

const toast = (options = {}) => {
  let opts = options;
  // if (typeof opts === 'string' || isVNode(opts)) {
  if (typeof opts === 'string') {
    opts = { message: opts };
  }

  opts = {
    placement: 'top',
    duration: 3000,
    ...opts,
  };

  let verticalOffset = opts.offset || 20;
  toasts[opts.placement].forEach(({ vm }) => {
    verticalOffset += (vm.el.offsetHeight || 0) + TOAST_GAP;
  });

  verticalOffset += TOAST_GAP;
  const id = `toast_${Math.floor(Math.random() * 10000)}`;
  const afterClose = opts.onClose;

  const props = {
    ...opts,
    offset: verticalOffset,
    id,
    onClose: () => {
      close(id, opts.placement, afterClose);
    },
  };

  const wrapper = document.createElement('div');
  wrapper.className = `wrapper_${id}`;

  const vm = h(
    Toast,
    {
      ...props,
      onDestroy: () => {
        render(null, wrapper);
      },
    },
  );
  render(vm, wrapper);
  const removeNum = toasts[opts.placement].length - props.max;
  toasts[opts.placement].push({ vm });
  if (opts.toastContainerId && document.getElementById(opts.toastContainerId)) {
    wrapper.firstElementChild.classList.add('toast-pos');
    document.getElementById(props.toastContainerId).style.position = 'relative';
    document
      .getElementById(opts.toastContainerId)
      .appendChild(wrapper.firstElementChild);
  } else {
    document.body.appendChild(wrapper.firstElementChild);
  }

  if (removeNum > -1 && props.duration === 0) {
    const { component } = toasts[opts.placement][0].vm;
    component.proxy.visible = false;
  }
  return {

    close: () => {
      vm.component.proxy.visible = false;
    },
  };
};

export default toast;
